<div class="modal-backdrop">
  <div class="modal-container">
    <div class="modal">
      <div class="modal-header">
        <h3 class="modal-title">
          <mat-icon>file_download</mat-icon>
          Exportar Resultados
        </h3>
      </div>
      <mat-dialog-content class="modal-body">
        @if (!isExporting()) {
          <div class="format-selection">
            <p class="selection-label">Selecione o formato de exportação:</p>
            <div class="format-options">
              <button 
                mat-raised-button 
                class="format-option"
                [class.selected]="selectedFormat() === 'pdf'"
                (click)="selectFormat('pdf')"
                [disabled]="isExporting()"
                style="height: 80px; display: flex; align-items: center; justify-content: flex-start;">
                <div class="format-content">
                  <mat-icon class="format-icon" style="margin-right: 8px;">{{ getFormatIcon('pdf') }}</mat-icon>
                  <div class="format-info">
                    <span class="format-name">PDF</span>
                    <span class="format-description">{{ getFormatDescription('pdf') }}</span>
                  </div>
                </div>
              </button>
              <button 
                mat-raised-button 
                class="format-option"
                [class.selected]="selectedFormat() === 'excel'"
                (click)="selectFormat('excel')"
                [disabled]="isExporting()"
                style="height: 80px; display: flex; align-items: center; justify-content: flex-start;">
                <div class="format-content">
                  <mat-icon class="format-icon" style="margin-right: 8px;">{{ getFormatIcon('excel') }}</mat-icon>
                  <div class="format-info">
                    <span class="format-name">Excel</span>
                    <span class="format-description">{{ getFormatDescription('excel') }}</span>
                  </div>
                </div>
              </button>
              <button 
                mat-raised-button 
                class="format-option"
                [class.selected]="selectedFormat() === 'csv'"
                (click)="selectFormat('csv')"
                [disabled]="isExporting()"
                style="height: 80px; display: flex; align-items: center; justify-content: flex-start;">
                <div class="format-content">
                  <mat-icon class="format-icon" style="margin-right: 8px;">{{ getFormatIcon('csv') }}</mat-icon>
                  <div class="format-info">
                    <span class="format-name">CSV</span>
                    <span class="format-description">{{ getFormatDescription('csv') }}</span>
                  </div>
                </div>
              </button>
            </div>
            <div class="export-info">
              <mat-icon>info</mat-icon>
              <span>{{ data.results.length }} resultado(s) será(ão) exportado(s)</span>
            </div>
          </div>
        }
        @if (isExporting()) {
          <div class="export-progress">
            <mat-spinner diameter="60"></mat-spinner>
            <p class="progress-message">{{ exportProgress().message }}</p>
            <mat-progress-bar 
              mode="determinate" 
              [value]="exportProgress().progress">
            </mat-progress-bar>
            <p class="progress-percentage">{{ exportProgress().progress }}%</p>
          </div>
        }
      </mat-dialog-content>
      <mat-dialog-actions class="modal-footer" align="end">
        <button 
          mat-button 
          (click)="cancel()"
          [disabled]="isExporting()">
          Cancelar
        </button>
        <button 
          mat-raised-button 
          color="primary" 
          (click)="export()"
          [disabled]="isExporting()">
          <mat-icon>file_download</mat-icon>
          Exportar
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
